module.exports = __webpack_public_path__ + "img/del_btn_solid.b593c0f1.png";